import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ContactDetailsHistory } from '../../../models/contact-details-history/contact-details-history.model';
import { ContactDetailsHistorySerializer } from '../../../models/contact-details-history/contact-details-history-serializer.class';
import { CustomErrorHandlerService } from '../custom-error-handler.service';

@Injectable()
export class ContactDetailsHistoryService extends BaseApiService<ContactDetailsHistory> {
  constructor(httpClient: HttpClient) {
    super(
        httpClient, 
        null, 
        "contactdetailshistory", 
        new ContactDetailsHistorySerializer(), 
        new CustomErrorHandlerService());
  }
}
